import { Compass as IconCompass } from "@phosphor-icons/react";

const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 40px)',
    gridTemplateRows: 'repeat(3, 40px)',
    gap: '5px',
    padding: '10px'
};

const cellStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #616465',
    borderRadius: '4px',
};

const DirectionGrid = ({ data }) => {
    return (
        <div style={gridStyle}>
            <Cell row={1} col={1} val={data?.NW} />
            <Cell row={1} col={2} val={data?.N} />
            <Cell row={1} col={3} val={data?.NE} />
            <Cell row={2} col={1} val={data?.W} />
            <div style={{ ...cellStyle, gridRow: 2, gridColumn: 2 }}><IconCompass size={16} /></div>
            <Cell row={2} col={3} val={data?.E} />
            <Cell row={3} col={1} val={data?.SW} />
            <Cell row={3} col={2} val={data?.S} />
            <Cell row={3} col={3} val={data?.SE} />
        </div>
    );
};

const Cell = ({row, col, val}) => {
    const c1 = !(val.count>0) ? 'text-gray' : '';
    const c2 = val.hasSighting ? 'text-yellow' : '';
    return (
        <div style={{ ...cellStyle, gridRow: row, gridColumn: col }} className={`${c1} ${c2}`}>{val.count}</div>
    )
}

export default DirectionGrid;
